import React from "react";
import { useSelector } from "react-redux";
import { Bar } from "react-chartjs-2";
import { ChartData } from "chart.js";
import { useTranslation } from "react-i18next";

import { RootState } from "../../../../../store/store";
import ChartLegend from "../../ChartLegend/ChartLegend";
import { horizontalChartOptions } from "../../../../../utils/charts/chartOptions";

import theme from "../../../../../components/styles/theme/theme";

const EmploymentSectorChart: React.FC = () => {
  const { t } = useTranslation();

  const {
    statistics: { statisticsForSelectedCountry },
  } = useSelector((state: RootState) => state);

  const labels = [
    t("charts.trade_label"),
    t("charts.publicServices_label"),
    t("charts.businessServices_label"),
    t("charts.manufacturing_label"),
    t("charts.transport_label"),
    t("charts.system_label"),
    t("charts.other_industry_label"),
    t("charts.agriculture_label"),
  ];

  const statisticsDataArray = [
    [
      0,
      0,
      0,
      0,
      0,
      statisticsForSelectedCountry?.employment_bySector
        .TCCS_theCocaColaSystem || 0,
      0,
      0,
    ],
    [
      statisticsForSelectedCountry?.employment_bySector
        .trade_suppliers_and_outlets || 0,
      statisticsForSelectedCountry?.employment_bySector
        .publicServices_suppliers_and_outlets || 0,
      statisticsForSelectedCountry?.employment_bySector
        .buesinessServices_suppliers_and_outlets || 0,
      statisticsForSelectedCountry?.employment_bySector
        .manufacturing_suppliers_and_outlets || 0,
      statisticsForSelectedCountry?.employment_bySector
        .transport_suppliers_and_outlets || 0,
      0,
      statisticsForSelectedCountry?.employment_bySector
        .otherIndustry_suppliers_and_outlets || 0,
      statisticsForSelectedCountry?.employment_bySector
        .agriculture_suppliers_and_outlets || 0,
    ],
    [
      statisticsForSelectedCountry?.employment_bySector
        .trade_suppliers_and_outlets_suppliers || 0,
      statisticsForSelectedCountry?.employment_bySector
        .publicServices_suppliers_and_outlets_suppliers || 0,
      statisticsForSelectedCountry?.employment_bySector
        .buesinessServices_suppliers_and_outlets_suppliers || 0,
      statisticsForSelectedCountry?.employment_bySector
        .manufacturing_suppliers_and_outlets_suppliers || 0,
      statisticsForSelectedCountry?.employment_bySector
        .transport_suppliers_and_outlets_suppliers || 0,
      0,
      statisticsForSelectedCountry?.employment_bySector
        .otherIndustry_suppliers_and_outlets_suppliers || 0,
      statisticsForSelectedCountry?.employment_bySector
        .agriculture_suppliers_and_outlets_suppliers || 0,
    ],
  ];

  const sortedArrayOfObj = labels
    .map(function (d, index) {
      const sortedValues = statisticsDataArray.map((row) => row[index] || 0);

      return {
        label: d,
        statisticsDataArray: sortedValues,
      };
    })
    .sort(function (a, b) {
      return (
        b.statisticsDataArray.reduce((acc, curr) => acc + curr, 0) -
        a.statisticsDataArray.reduce((acc, curr) => acc + curr, 0)
      );
    });

  const newLabels = sortedArrayOfObj.map((obj) => obj.label);
  const newStatisticsDataArray = sortedArrayOfObj.map(
    (obj) => obj.statisticsDataArray
  );

  const transformedSortedStatisticsDataArray = Array.from(
    { length: newStatisticsDataArray[0].length },
    (_, i) => newStatisticsDataArray.map((arr) => arr[i])
  ).map((row) => row.map((value) => (value === 0 ? null : value)));
// @ts-ignore
  const data: ChartData<"bar"> = {
    labels: newLabels,
    datasets: [
      {
        label: t("charts.system_label") || "",
        data: transformedSortedStatisticsDataArray[0],
        backgroundColor: theme.palette.secondary["600"],
        minBarLength: 5,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
        order: 1,
      },
      {
        label: t("charts.first_tier_suppliers_and_outlets_label") || "",
        data: transformedSortedStatisticsDataArray[1],
        backgroundColor: theme.palette.secondary["200"],
        minBarLength: 5,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
        order: 2,
      },
      {
        label: t("charts.suppliers_of_suppliers_and_outlets_label") || "",
        data: transformedSortedStatisticsDataArray[2],
        backgroundColor: theme.palette.secondary["50"],
        minBarLength: 5,
        borderWidth: 1,
        borderColor: theme.palette.common.white,
        order: 3,
      },
    ],
  };

  return (
    <>
      <Bar options={horizontalChartOptions("employment")} data={data} />
      <ChartLegend data={data} />
    </>
  );
};

export default EmploymentSectorChart;
